import { Dialog, DialogContent } from 'components/UI/Modal/ModalPrimitive'
import { useEffect } from 'react'
import { UseFormReturn } from 'react-hook-form'
import { featureFlagService } from 'utils/featureFlagService'
import { ProductDetailsStep } from './ProductDetailsStep'
import { ProductModalProvider } from './ProductModalContext'
import { ProductVariantsStep } from './ProductVariantsStep'
import { SalesPotentialStep } from './SalesPotentialStep'

export function ProductModal({
  show,
  handleClose,
  selectedProductID,
  defaultValues,
  productForm,
  espForm,
  onSubmit,
  step,
  setStep,
}: {
  show: boolean
  handleClose: () => void
  selectedProductID?: number
  defaultValues: any
  productForm: UseFormReturn<any>
  espForm: UseFormReturn<any>
  onSubmit: () => Promise<void>
  step: number
  setStep: (step: number) => void
}) {
  const { useNewProductCatalog } = featureFlagService()

  // Dynamically set total steps based on feature flag
  // Flag ON: 2 steps (Details → Sales Potential)
  // Flag OFF: 3 steps (Details → Sales Potential → Variants)
  const totalSteps = useNewProductCatalog ? 2 : 3

  // Reset step when modal closes
  useEffect(() => {
    if (!show) {
      setStep(0)
    }
  }, [show])

  // Create a wrapper for handleClose that ensures step is reset
  const handleModalClose = () => {
    setStep(0)
    handleClose()
  }

  return (
    <Dialog open={show} onOpenChange={(open) => !open && handleModalClose()}>
      <DialogContent id={'fb-modal-content'} size="lg" className="px-3">
        <ProductModalProvider
          handleClose={handleModalClose}
          selectedProductID={selectedProductID}
          defaultValues={defaultValues}
          productForm={productForm}
          espForm={espForm}
          onSubmit={onSubmit}
        >
          {step === 0 && (
            <ProductDetailsStep
              onNext={() => setStep(1)}
              totalSteps={totalSteps}
            />
          )}
          {step === 1 && (
            <SalesPotentialStep
              onBack={() => setStep(0)}
              onNext={useNewProductCatalog ? undefined : () => setStep(2)}
              totalSteps={totalSteps}
            />
          )}
          {/* Step 3: Only show when flag is OFF (old 3-step flow) */}
          {!useNewProductCatalog && step === 2 && (
            <ProductVariantsStep onBack={() => setStep(1)} />
          )}
        </ProductModalProvider>
      </DialogContent>
    </Dialog>
  )
}
